import React from "react";
import { InfoBlock } from "ComponentsUIV2/Blocks";
import { SVGFiveStars, SVGClass } from "Constants/SVG";
import { isMainSiteCode, isMoscowSiteCode } from "Utils/siteConfig";

import { pipe } from "Utils";
import { observer, inject } from "mobx-react";

const InfoBlockContainer = (props) => {
	const {
		ApplicationModel: { siteCode, text },
	} = props;

	let teamName = isMainSiteCode(siteCode)
		? text.internet_101
		: isMoscowSiteCode(siteCode)
			? text.moscow_online
			: text.piter_online;
	let yandex = isMainSiteCode(siteCode) ? (
		<a href="https://yandex.by/maps/org/101_internet/118153615879/reviews/?display-text=101 интернет&ll=37.746499%2C55.685574&mode=search&sll=37.746499%2C55.685574&sspn=0.075703%2C0.024875&tab=reviews&text=101 интернет&z=14">
			{text.yandex}
		</a>
	) : isMoscowSiteCode(siteCode) ? (
		<a href="https://yandex.by/maps/org/moskva_onlayn/1035796011/reviews/?ll=37.645744%2C55.757744&z=13">
			{text.yandex}
		</a>
	) : (
		text.yandex
	);
	let google = isMainSiteCode(siteCode) ? (
		<a href="https://www.google.com/maps/place/101INTERNET.RU/@55.685594,37.7465649,15z/data=!4m8!3m7!1s0x414ab5d1d59c3dfb:0x828917e39f1991eb!8m2!3d55.685594!4d37.7465649!9m1!1b1!16s%2Fg%2F11f7dt13b6?entry=ttu">
			{text.google}
		</a>
	) : (
		text.google
	);

	const mainTeamName = text.team + text.space + teamName;
	const viewVacancies = (
		<>
			{text.show + text.space}
			<a href="https://hh.ru/employer/800646">{text.vacancies}</a>
		</>
	);
	const ratingText = (
		<span>
			{text.set_by_users + text.space + teamName + text.space + text.on + text.space}
			{yandex}
			{text.space + text.and + text.space}
			{google}
			{text.space + text.maps}
		</span>
	);
	const recommendationText = (
		<span>
			{text.our_employees + text.space}
			<a href="https://dreamjob.ru/employers/110998">{text.recommend}</a>
			{text.space + text.work_at + text.space + teamName}
		</span>
	);
	const jobsList = (
		<ul>
			<li>Команда тестирования</li>
			<li>Product и Project менеджеры</li>
			<li>Команда разработки</li>
			<li>Delivery менеджеры</li>
			<li>Отдел продаж</li>
			<li>Аналитики</li>
			<li>Команда SEO</li>
			<li>Дизайнеры</li>
			<li>HR- менеджеры</li>
		</ul>
	);

	return (
		<div style={{ display: "flex", flexWrap: "wrap" }}>
			<InfoBlock
				svg={SVGFiveStars}
				header={text.grade_5}
				text={ratingText}
				background={true}
				marginRight={true}
			/>
			<InfoBlock
				svg={SVGClass}
				header={text.percent_100}
				text={recommendationText}
				background={true}
			/>
			<InfoBlock header={mainTeamName} text={jobsList} marginRight={true} />
			<InfoBlock header={viewVacancies} />
		</div>
	);
};

export default pipe(observer, inject("ApplicationModel"))(InfoBlockContainer);
